import moment from 'moment';

const formatters = {};

formatters.boolToYesNo = boolVal => ((!!boolVal === true) ? 'Yes' : 'No');
formatters.boolToYes = boolVal => ((!!boolVal === true) ? 'Yes' : '');

formatters.number = (num, decimals) => {
  if (typeof decimals !== 'number') {
    decimals = 2;
  }

  return (num || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

formatters.currency = (amount) => {
  const sign = amount < 0 ? '-' : '';
  const abs = Math.abs(amount);

  return `${sign}$${formatters.number(abs)}`;
};

formatters.datetime = iso => (iso ? moment(iso).format('ddd, MMM D YYYY h:mm A') : '');

export default formatters;
